import { render, staticRenderFns } from "./MobileTabbedContent.vue?vue&type=template&id=6ab12827&scoped=true"
import script from "./MobileTabbedContent.vue?vue&type=script&lang=js"
export * from "./MobileTabbedContent.vue?vue&type=script&lang=js"
import style0 from "./MobileTabbedContent.vue?vue&type=style&index=0&id=6ab12827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab12827",
  null
  
)

export default component.exports